const config = {
	endpoints: {
		docs: 'https://github.com/growthops-digital/datocms-plugin-visual-select#readme',
		issues: 'https://github.com/growthops-digital/datocms-plugin-visual-select/issues',
		changelog: 'https://github.com/growthops-digital/datocms-plugin-visual-select/blob/main/CHANGELOG.md',
	},
};

export default config;
